import React from 'react'
import { Container, ContainerProps, styled } from '@mui/material'
import { useSidebarWidth } from '@store/app'

export type ContentProps = ContainerProps & {
  children: React.ReactNode;
  spacing?: number;
  spacingX?: number;
  spacingY?: number;
}

const Content = styled(
  ({ children, maxWidth = 'xl', sx, ...props }: ContentProps) => {
    const sideBarWidth = useSidebarWidth()

    props = { ...props }
    delete props.spacing
    delete props.spacingX
    delete props.spacingY

    sx = Object.assign({}, sx || {}, {
      width: `calc(100% - ${sideBarWidth}px)`,
      marginLeft: `${sideBarWidth}px`,
    })

    return (
      <Container {...props} maxWidth={maxWidth} sx={sx}>
        {children}
      </Container>
    )
  }
)(({ theme, spacing, spacingX, spacingY }) => ({
  boxSizing: 'border-box',
  '&&': {
    padding: theme.spacing(2, 0.5, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(
        spacingY || spacing || 2.5,
        spacingX || spacing || 2.5
      ),
    }
  }
}))

export default Content